import React from 'react';

/** Minimal tennis-ball glyph: a circle with the two seam curves. */
export function TennisBallIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" className={className} aria-hidden="true" focusable="false" data-id="element-168" data-mp="2rmqusa7pvw35">
      <circle cx="12" cy="12" r="9" data-id="element-169" data-mp="2ioycqyam2ac2" />
      <path d="M4.2 7.2A9 9 0 0 1 9.8 20.6" data-id="element-170" data-mp="2ipzz3yx2uj93" />
      <path d="M19.8 7.2A9 9 0 0 0 14.2 20.6" data-id="element-171" data-mp="36esmv83jpksm" />
    </svg>;
}